import { DownOutlined, RightOutlined, StarFilled } from "@ant-design/icons"
import { useState } from "react";

const AddJobsByMapLegend = () => {
  const [isLegendExpanded, setIsLegendExpanded] = useState(true);

  return               <div
  style={{
    position: 'absolute',
    bottom: '20px',
    right: '10px',
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '12px',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    zIndex: 1,
    fontSize: '12px',
    minWidth: '150px'
  }}
>
  <div 
    style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      cursor: 'pointer'
    }}
    onClick={() => setIsLegendExpanded(!isLegendExpanded)}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {isLegendExpanded ? (
        <DownOutlined style={{ fontSize: '12px' }} />
      ) : (
        <RightOutlined style={{ fontSize: '12px' }} />
      )}
      <div style={{ fontWeight: 'bold' }}>Legend</div>
    </div>
  </div>
  
  {isLegendExpanded && (
    <div style={{ marginTop: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
        <div style={{ 
          position: 'relative',
          width: '15px',
          height: '22px',
          marginRight: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          {/* Pin head (circle) */}
          <div style={{
            width: '15px',
            height: '15px',
            backgroundColor: '#ADC6FF',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid #061178',
            boxShadow: '0 0 2px rgba(0,0,0,0.3)',
            zIndex: 2
          }}>
            <div style={{
              width: '4px',
              height: '4px',
              backgroundColor: 'white',
              borderRadius: '50%',
              border: '2px solid #061178'
            }} />
          </div>
          {/* Pin tail (triangle) */}
          <div style={{
            width: '10px',
            height: '10px',
            backgroundColor: '#ADC6FF',
            clipPath: 'polygon(50% 100%, 0 0, 100% 0)',
            marginTop: '-3px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
            zIndex: 1
          }} />
        </div>
        <span>Unselected Job</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
        <div style={{ 
          position: 'relative',
          width: '15px',
          height: '22px',
          marginRight: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          {/* Pin head (circle) */}
          <div style={{
            width: '15px',
            height: '15px',
            backgroundColor: '#FFCABD',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid #FF5C35',
            boxShadow: '0 0 2px rgba(0,0,0,0.3)',
            zIndex: 2
          }}>
            <div style={{
              width: '4px',
              height: '4px',
              backgroundColor: 'white',
              borderRadius: '50%',
              border: '2px solid #FF5C35'
            }} />
          </div>
          {/* Pin tail (triangle) */}
          <div style={{
            width: '10px',
            height: '10px',
            backgroundColor: '#FFCABD',
            clipPath: 'polygon(50% 100%, 0 0, 100% 0)',
            marginTop: '-3px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
            zIndex: 1
          }} />
        </div>
        <span>Selected Job</span>
      </div>
      {/* Shop Marker Legend Item - Moved to bottom */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ 
          position: 'relative',
          width: '15px',
          height: '22px',
          marginRight: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <div style={{
            width: '15px',
            height: '15px',
            backgroundColor: '#CCCCCC',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid #000000',
            boxShadow: '0 0 2px rgba(0,0,0,0.3)',
            zIndex: 2
          }}>
            <StarFilled style={{ color: '#000000', fontSize: '8px' }} />
          </div>
          <div style={{
            width: '10px',
            height: '10px',
            backgroundColor: '#CCCCCC',
            clipPath: 'polygon(50% 100%, 0 0, 100% 0)',
            marginTop: '-3px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
            zIndex: 1
          }} />
        </div>
        <span>My Shop</span>
      </div>
    </div>
  )}
</div>
}

export default AddJobsByMapLegend